import { useAuth as useAuthContext2 } from 'src/contexts/AuthContext';

export const useAuth = useAuthContext2;

export default useAuth;
